import { lockScroll, unlockScroll } from '../utils/util-functions';

export default (node) => {
  const menuToggle = node.querySelector('[data-menu-toggle]');
  const mobileMenu = node.querySelector('[data-mobile-menu]');
  const iconClose = node.querySelectorAll('[data-icon-close-menu]');
  const megaMenuItems = node.querySelectorAll('[data-mega-menu]');
  const searchButtons = node.querySelectorAll('[data-search-button]');
  const cartButtons = node.querySelectorAll('[data-cart-button]');

  // Toggle Mobile Menu
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isHidden = mobileMenu.classList.contains('hidden');

      mobileMenu.classList.toggle('translate-x-0');
      mobileMenu.classList.toggle('translate-x-full');
      if (isHidden) {
        mobileMenu.classList.remove('hidden');
        lockScroll();
        cartButtons.forEach((button) => {
          button.classList.add('hidden');
        });
      } else {
        mobileMenu.classList.add('hidden');
        unlockScroll();

        cartButtons.forEach((button) => {
          button.classList.remove('hidden');
        });
      }
    });
  }

  // Monitor Mega Menu State on Desktop
  megaMenuItems.forEach((megaMenu) => {
    const parent = megaMenu.closest('.group');

    parent.addEventListener('mouseenter', () => {
      lockScroll(); // Disable scrolling when hovering over a mega menu
    });

    parent.addEventListener('mouseleave', () => {
      unlockScroll(); // Re-enable scrolling when leaving the mega menu
    });
  });

  // Handle Window Resize
  const handleResize = () => {
    const isMobileView = window.innerWidth < 1150; // Tailwind's 'md' breakpoint (768px)
    if (!isMobileView) {
      // Hide mobile menu and reset scrolling when switching to desktop
      mobileMenu.classList.add('hidden');
      unlockScroll();
    }
  };

  window.addEventListener('resize', handleResize);

  const init = () => {
    searchButtons.forEach((button) => {
      button.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('search:open'));
        document.dispatchEvent(new CustomEvent('localize-menu:close'));
        document.dispatchEvent(new CustomEvent('help-menu:close'));
      });
    });

    iconClose.forEach((button) => {
      button.addEventListener('click', () => {
        mobileMenu.classList.add('hidden');
        unlockScroll();
        // Toggle icon visibility
        mobileMenu.classList.toggle('translate-x-0');
        mobileMenu.classList.toggle('translate-x-full');
        cartButtons.forEach((button) => {
          button.classList.remove('hidden');
        });
        searchButtonMobile.classList.remove('hidden');
      });
    });

    cartButtons.forEach((button) => {
      button.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('cart:open'));
        document.dispatchEvent(new CustomEvent('localize-menu:close'));
        document.dispatchEvent(new CustomEvent('help-menu:close'));
      });
    });
  };

  init();
};
